
import {
  Component,
  Vue,
  Prop,
} from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import ElementTipTap from '@/components/ElementTipTap/index.vue';

@Component({
  name: 'BasicForm',
  components: {
    ElementTipTap,
  },
})
export default class extends Vue {
  private formData = {
    detailDescription: '',
  };

  get industry() {
    return UserModule.industry;
  }

  private rules = {
    deliveryFee: [
      { required: true, message: '배송비를 입력하세요.', trigger: 'blur' },
    ],
    detailDescription: [
      { required: true, message: '시설분류를 선택하세요.', trigger: 'blur' },
    ],
  };

  private defaultCk = false;

  private defaultRefundInfo = '<h2><strong>주문 취소 안내</strong></h2><ul><li><p>주문완료 후 7일 이내에 상품 결제대금을 입금해 주셔야 하며,<br>7일 이후에는 주문내역이 자동으로 취소 및 삭제되오니 이점 유의해 주시기 바랍니다.</p></li></ul><ul><li><p>즉시 주문취소는 배송준비가 이루어지기 전 단계까지 가능하시며</p><p>배송준비 단계부터의 취소는 주문취소 신청을 하시면 담당자를 통해 취소 과정이 진행됩니다.</p><p><br class="ProseMirror-trailingBreak"></p></li><li><p>취소하신 결제 방법 중 쿠폰은 반환되지 않으며, 다중 결제(포인트+신용카드 등)의 경우 </p><p>결제 시 사용된 비율에 따라 자동 산정되어 환급됩니다.</p></li></ul><hr contenteditable="false"><h1><strong>반품 및 환불 안내</strong></h1><ul><li><p>제품에 이상이 없거나 고객님의 기호, 단순변심일 경우엔 교환, 환불이 되지 않습니다.</p></li></ul><ul><li><p>개봉하지 않고 포장상태가 양호할 경우엔 교환, 환불이 가능합니다.</p><p>(단, 왕복 택배비용은 고객님이 부담하셔야 합니다.)</p></li></ul><ul><li><p>반품일 경우 저희 제품이 발송된 택배회사로 반품해 주시면 됩니다.</p></li></ul><ul><li><p>주문하신 상품과 다른 상품이 배송되었거나 파손된 경우 반품처리 후 교환이 가능합니다.</p></li></ul><ul><li><p>오발송 및 파손된 상품에 대한 내용은 1:1 문의 또는 고객센터로 문의 주시기 바랍니다.</p></li></ul><ul><li><p>월~금요일(오전9시부터 오후6시까지), 주 5일 근무</p><p>점심시간 PM12:00~PM 13:00</p></li></ul><ul><li><p>토요일, 일요일, 국공휴일 휴무</p></li></ul><h3><strong>반품 주소 : 경상남도 함양군 함양읍 용평4길 13</strong></h3><p><br class="ProseMirror-trailingBreak"></p>';

  private handleDefaultCk() {
    this.defaultCk = !this.defaultCk;
    if (this.defaultCk) this.formData.detailDescription = this.defaultRefundInfo;
    else this.formData.detailDescription = '';
  }

  private handleChangeEditor(value: any) {
    this.formData.detailDescription = value;
  }
}
